import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginationModule } from 'ngx-bootstrap/pagination';
// import { LbdModule } from '../../lbd/lbd.module';
import { NguiMapModule} from '@ngui/map';
import { LbdModule } from '../lbd/lbd.module';

import { ContabilidadRoutes } from './contabilidad.routing';

import { ContabilidadElectronicaCsdListaComponent } from './catalogo/contabilidad-electronica-csd/contabilidad-electronica-csd-lista/contabilidad-electronica-csd-lista.component';


import { CatalogoUsuarioComponent } from './catalogo/usuario/catalogo-usuario/catalogo-usuario.component';
import { FormularioUsuarioComponent } from './catalogo/usuario/formulario-usuario/formulario-usuario.component';
import { CatalogoCtbConfComponent } from './catalogo/ctb-conf/catalogo-ctb-conf/catalogo-ctb-conf.component';
import { FormularioCtbConfComponent } from './catalogo/ctb-conf/formulario-ctb-conf/formulario-ctb-conf.component';

import { ReporteCtbCtaComponent } from './reportes/contabilidad/reporte-ctb-cta/reporte-ctb-cta.component';
import { CatalogoCtbCtaComponent } from './catalogo/ctb-cta/catalogo-ctb-cta/catalogo-ctb-cta.component';
import { FormularioCtbCtaComponent } from './catalogo/ctb-cta/formulario-ctb-cta/formulario-ctb-cta.component';
import { CatalogoCtbTpolComponent } from './catalogo/ctb-tpol/catalogo-ctb-tpol/catalogo-ctb-tpol.component';
import { FormularioCtbTpolComponent } from './catalogo/ctb-tpol/formulario-ctb-tpol/formulario-ctb-tpol.component';

import {CatalogoBancosComponent} from './catalogo/bancos/catalogo-bancos/catalogo-bancos.component';
import {FormularioBancosComponent} from './catalogo/bancos/formulario-bancos/formulario-bancos.component';

import {CatalogoCuentasBancariasComponent} from './catalogo/cuentas-bancarias/catalogo-cuentas-bancarias/catalogo-cuentas-bancarias.component';
import {FormularioCuentasBancariasComponent} from './catalogo/cuentas-bancarias/formulario-cuentas-bancarias/formulario-cuentas-bancarias.component';

import {CatalogoConceptoComponent} from './catalogo/conceptos/catalogo-concepto/catalogo-concepto.component';
import {FormularioConceptoComponent} from './catalogo/conceptos/formulario-concepto/formulario-concepto.component';

import {CatalogoCtbCcComponent} from './catalogo/ctb-cc/catalogo-ctb-cc/catalogo-ctb-cc.component';
import {FormularioCtbCcComponent} from './catalogo/ctb-cc/formulario-ctb-cc/formulario-ctb-cc.component';

import {CatalogoGralMonComponent} from './catalogo/gral-mon/catalogo-gral-mon/catalogo-gral-mon.component';
import {FormularioGralMonComponent} from './catalogo/gral-mon/formulario-gral-mon/formulario-gral-mon.component';

import { CatalogoCtbPolComponent } from './catalogo/ctb-pol/catalogo-ctb-pol/catalogo-ctb-pol.component';
import { FormularioCtbPolComponent } from './catalogo/ctb-pol/formulario-ctb-pol/formulario-ctb-pol.component';

import { ReporteBalanceGeneralComponent } from './reportes/contabilidad/balance-general/reporte-balance-general.component';

import { EstadoResultadosComponent } from './reportes/contabilidad/estado-resultados/estado-resultados.component';

import {RepAuxMovComponent} from './catalogo/rep-aux-mov/rep-aux-mov.component';

import { BalanzaComprobacionComponent } from './reportes/contabilidad/balanza-comprobacion/balanza-comprobacion.component';

import { ContabilidadElectronicaCsdComponent } from './catalogo/contabilidad-electronica-csd/contabilidad-electronica-csd.component';
import { ContabilidadElectronicaComponent } from './contabilidad-electronica/contabilidad-electronica.component';
import { CatalogoActFijoComponent } from './catalogo/ctb-act-fijo/catalogo-act-fijo/catalogo-act-fijo.component';
import { ComponentActFijoComponent } from './catalogo/ctb-act-fijo/component-act-fijo/component-act-fijo.component';
import { DepreciarActFijoComponent } from './catalogo/depreciar-activo-fijo/depreciar-act-fijo.component';
import { ValuacionMonedaExtranjeraComponent } from './catalogo/valuacion-moneda-extranjera/formulario/valuacion-moneda-extranjera.component';
import { CatalogoValuacionMonedaExtranjeraComponent } from './catalogo/valuacion-moneda-extranjera/catalogo/catalogo-valuacion-moneda-extranjera.component';
import { PolizaCierreComponent } from './catalogo/poliza-cierre/poliza-cierre.component';
import { SatDescargaDocComponent } from './catalogo/sat-descarga-doc/sat-descarga-doc.component';
import { AddDocComponent } from './catalogo/add-doc/add-doc.component';
import { CtbDiotComponent } from './catalogo/ctb-diot/ctb-diot.component';
import { ValuarMonExtComponent } from './catalogo/valuar-mon-ext/valuar-mon-ext.component';
import { PuntoEquilibrioComponent } from './reportes/contabilidad/punto-equilibrio/punto-equilibrio.component';
import { BalanzaComprobacionCcComponent } from './reportes/cc/balanza-comprobacion-cc/balanza-comprobacion-cc.component';
import { EstadoResultadosCcComponent } from './reportes/cc/estado-resultados-cc/estado-resultados-cc.component';
import { GastosSucursalComponent } from './reportes/cc/gastos-sucursal/gastos-sucursal.component';
import { IvaPagClieComponent } from './reportes/fiscales/iva-pag-clie/iva-pag-clie.component';
import { IvaPagProvComponent } from './reportes/fiscales/iva-pag-prov/iva-pag-prov.component';
import { CtbBalanzaComprobacionDinComponent } from './reportes/contabilidad_din/ctb-balanza-comprobacion-din/ctb-balanza-comprobacion-din.component';
import { CtbBalanceGeneralDinComponent } from './reportes/contabilidad_din/ctb-balance-general-din/ctb-balance-general-din.component';
import { CtbEstadoResultadosDinComponent } from './reportes/contabilidad_din/ctb-estado-resultados-din/ctb-estado-resultados-din.component';
import { ScrollingModule } from '@angular/cdk/scrolling'; // <--- IMPORTANTE
import { NgSelectModule } from '@ng-select/ng-select';
import { DeepseekChatModule } from '../deepseek/r1/chat/deepseek-chat.module';
@NgModule({
  imports: [
    CommonModule, DeepseekChatModule,ScrollingModule,
    LbdModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(ContabilidadRoutes),
    PaginationModule.forRoot(),
    NgSelectModule
  ],
  declarations: [
  //  HomeComponent,
    ReporteBalanceGeneralComponent,
    CatalogoUsuarioComponent,
    FormularioUsuarioComponent,
    FormularioCtbPolComponent,
    BalanzaComprobacionComponent,
    EstadoResultadosComponent,
    CatalogoCtbPolComponent,
    PolizaCierreComponent,
    // IconsComponent,
    CatalogoCtbConfComponent,
    CatalogoCtbCtaComponent,
    FormularioCtbConfComponent,
    ReporteCtbCtaComponent,
    FormularioCtbCtaComponent,
    ContabilidadElectronicaComponent,
    DepreciarActFijoComponent,
    CatalogoCtbTpolComponent,
    ContabilidadElectronicaCsdListaComponent,
    FormularioCtbTpolComponent,
    CatalogoBancosComponent,
    FormularioBancosComponent,
    ContabilidadElectronicaCsdComponent,
    CatalogoCuentasBancariasComponent,
    FormularioCuentasBancariasComponent,
    CatalogoConceptoComponent,
    FormularioConceptoComponent,
    CatalogoCtbCcComponent,
    FormularioCtbCcComponent,IvaPagClieComponent,
    CatalogoGralMonComponent,
    FormularioGralMonComponent,
    RepAuxMovComponent,
    CatalogoActFijoComponent,
    ComponentActFijoComponent,
    ValuacionMonedaExtranjeraComponent,
    CatalogoValuacionMonedaExtranjeraComponent,
    SatDescargaDocComponent,
    AddDocComponent,
    CtbDiotComponent,
    ValuarMonExtComponent,
    PuntoEquilibrioComponent,
    BalanzaComprobacionCcComponent,
    EstadoResultadosCcComponent,
    GastosSucursalComponent,
    IvaPagClieComponent,
    IvaPagProvComponent,
    CtbBalanzaComprobacionDinComponent,
    CtbBalanceGeneralDinComponent,
    CtbEstadoResultadosDinComponent
  ]
})

export class ContabilidadModule {}
